<template>
  <div class="root">
    <div class="one">
        <el-button type="primary" v-if="false" size="mini" @click="click(0)" icon="el-icon-plus">增加</el-button>
        <div class="warp-block">
            <el-tree
            :props="defaultProps"
            :data="data"
            node-key="id"
            default-expand-all
            @node-click="emunClick"
            :expand-on-click-node="false">
            <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <!-- <span>{{ data.level }}</span> -->
                <div >
                    <!-- <img style="margin-left: 60px;" v-show="data.level != 2" @click="click(1,data,node)" src="../../../../../assets/custom-image/u9162.png" alt="">&nbsp;
                    <img src="../../../../../assets/custom-image/u9111.png" @click="click(2,data,node)" alt="">&nbsp;
                    <img src="../../../../../assets/custom-image/u9110.png" @click="click(3,data,node)" alt="">&nbsp; -->
                </div>
            </span>
            </el-tree>
        </div>
    </div>
    <div class="two" :style='{ height: this.$store.state.windowHeight - 350 + "px" }'>
        <div style="display: grid;height: 100%;width: 100%;" v-show="!isOne">
            <el-empty description="暂无位置区域">
            </el-empty>
        </div>
        <configuration ref="canvas" v-show="isOne"></configuration>
    </div>
    <el-dialog
         :title="dialog.title"
         :visible.sync="dialogVisibles"
         :width="width" :append-to-body	="true"
         :before-close="exit"
         :close-on-click-modal="false">
         
            <add ref="add" @close="close" v-if="index == 0 || index == 1 || index == 2" :operate="operates" :count="count" :edits="edit"></add>

         <span slot="footer" class="dialog-footer">
            <el-button @click="exit">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
         </span>
    </el-dialog>
  </div>
</template>

<script>
import {getFun,deleteFun,postFun} from '@/utils/httpFun'
import {operate} from '@/utils/config'
import add from './block_three_add.vue'
// import configuration from '../../../../components/configuration'
import configuration from '@/components/configuration'

export default {
    components:{
        add,
        configuration
    },
    props: {
    operate: {
      type: String,
      default: () => "add",
    },
    edits: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
        data:[],
        defaultProps: {
            label: 'name',
            children: 'structureVos'
        },
        canvas:{
            emunid:{},
            projectid:{}
        },
        dialog:{
            title:''
        },
        dialogVisibles:false,
        index:'',
        operates:'',
        edit:'',
        width:'30%',
        isShowTishi:true,
        isOne:false,            // 是否有位置区域
        count:0,
    }
  },
  methods: {
    exit(){
        this.index = -1;
        this.dialogVisibles = false;
    },
    close(){
        console.log('关闭')
        this.dialogVisibles = false;
        this.index = -1;
        this.threeList()
    },
    submit(){
        // this.dialogVisibles = false;
        this.$refs.add.addAgent()
    },
    async del(data,img,dlIdList,callback){
        let params = {
            id:this.canvas.emunid,              // 菜单id
            coordinateJson:data,                
            productionDrawing:img,
            projectId:this.canvas.projectid,
            dlIdList:dlIdList
        }
      
        console.log("上传施工图参数",params);
        
        await postFun(url.PROJECT.SAVEIMG,params,res=>{
            if(res.data){
                this.$message.success("删除成功")
                this.withdrawList = []
                callback && callback()
                // this.getProjectImg()
            }else{
                this.$message.warning("删除成功")
            }
        })
    },
    // 保存施工图
    async save(data,img,deviceList,callback){
        let params = {
            id:this.canvas.emunid,              // 菜单id
            coordinateJson:data,                
            productionDrawing:img,
            projectId:this.canvas.projectid,
            deviceLayouts:deviceList
        }
       
        console.log("上传施工图参数",params);
        
        await postFun(url.PROJECT.SAVEIMG,params,res=>{
            if(res.data){
                this.$message.success("保存成功")
                this.withdrawList = []
                callback && callback()
                this.getProjectImg();
            }else{
                this.$message.warning("保存失败")
            }
        })
    },
    authority(){
        let item = this.data[0];
        for(let i = 1;i<=3;i++){
            
            if(item.structureVos == null || item.structureVos == undefined || item.structureVos.length == 0){
                if(this.canvas.emunid == null || this.canvas.emunid == undefined || this.canvas.emunid == '' || ((typeof this.canvas.emunid) == 'object'))
                    this.canvas.emunid = item.id;
                this.canvas.projectid = this.edits.id
                
    
                this.getProjectImg();
                break;
            }
            item = item.structureVos[0];
        }
    },
    getCanvas() {
        return this.canvas;
    },
    emunClick(emun){
        // if(emun.level != 3 && emun.structureVos.length != 0 && this.isShowTishi){
        //     this.$message.warning("当前不是最后一级 无法增加施工图")
        //     return;
        // }
        this.canvas.emunid = emun.id;
        this.canvas.projectid = this.edits.id
        this.getProjectImg();
    },
     // 获取项目组的施工图
    async getProjectImg(){
        let id = this.canvas.emunid;
        let urls =operate.SPACESTRUCTURE+"/"+id
        await getFun(urls,{},res=>{
            this.canvasObj = res.data;

            this.$refs.canvas.setCanvas(res.data.coordinateJson == null?{}:JSON.parse(res.data.coordinateJson),res.data);
        })
    },
    click(index,obj,node){
        console.log('测试子菜单',this.edits)
        this.isShowTishi=false;
        this.index = index
        switch(index){
            case 0:
                // 要先调用接口
                this.dialogVisibles = true;
                this.operates = 'add';
                this.edit = this.edits;
                this.count = this.data.length + 1;
                this.dialog.title="增加"
            break;
            case 1:
                // 要先调用接口
                this.dialogVisibles = true;
                this.operates = "addChildren";
                this.edit = {emun:obj,project:this.edits};
                this.count = obj.structureVos.length + 1;
                this.dialog.title="增加"
            break;
            case 2:
    
                 // 要先调用接口
                 this.dialogVisibles = true;
                 this.operates = 'edit';
                 this.edit =  {projectId:this.edits.id,emun:obj}
                 this.dialog.title="编辑"
            break;
            case 3:

                this.$confirm(`你确认要删除, 是否继续?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                   
                    deleteFun(
                    `${url.PROJECT.DELTHREEMEUN}${obj.id}`,{},
                        (res) => {
                            if (res.data) {
                                this.$message({
                                    message: `删除成功`,
                                    type: "success",
                                });
                                this.canvas.emunid = null
                                    this.threeList(true)
                            } else {
                                this.$message.warning(`删除失败 已有安装设备`);
                            }
                        }
                    );
                })
                .catch(() => {
        
                });

            break;
            default:
                this.$message.warning("程序出错");
            break;
        }
        setTimeout(() => {this.isShowTishi=true},500)
    },
    async threeList(isDel= false) {
        
        let id = this.edits.id;
        await getFun(operate.GETSTUCTURE+"/"+id, {}, res => {
            this.data = res.data;

            this.isOne = true;
            try {
                this.data[0].id
            }catch (err) {
                this.isOne = false;
                return;
            }

            console.log('编辑222',this.canvas.emunid)

            if(this.canvas.emunid == null || this.canvas.emunid == undefined || this.canvas.emunid == '' || ((typeof this.canvas.emunid) == 'object'))
                this.canvas.emunid = this.data[0].id;
            else
                console.log('变化------------')
            this.authority();
        });
    },
    init() {
        this.threeList();
        this.canvas.projectid = this.edits.id;
    }
  },
  mounted(){
    this.init()
  }
};
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog__header{
    height: 23px;
    background: #F8F9FA;
    box-shadow: 0px 1px 0px 0px rgb(237 238 240);
    border-radius: 12px 12px 0 0;
   }
   ::v-deep .el-dialog{
    border-radius: 12px;
   }
.root{
    display: flex;
}
.one{
    width: 280px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 15px 10px 10px 10px;
    box-sizing: border-box;
    border-radius: 10px;
    .warp-block {
        overflow-y: auto;
    }
}
.two{
    border: 1px solid rgba(0, 0, 0, 0.1);
    flex: 1;
    margin-left: 15px;
    border-radius: 10px;
    overflow: hidden;
}
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
</style>